export default __webpack_public_path__ + "static/media/cat3-5.2b43fc29.jpg";